import { createFileRoute, useParams } from "@tanstack/react-router"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import { useEffect } from "react"

export const Route = createFileRoute(
  "/journalist/calls/$publicId/versions/$version"
)({
  ssr: false,
  component: RouteComponent,
})

function RouteComponent() {
  const { publicId } = useParams({
    from: "/journalist/calls/$publicId/versions/$version",
  })
  useEffect(() => {
    window.location.replace(`/call/${publicId}`)
  }, [publicId])
  return (
    <div className="flex w-full flex-col gap-2">
      <Skeleton className="mb-4 h-8 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="mb-4 h-5 w-1/2" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-1/4" />
    </div>
  )
}
